import { render, staticRenderFns } from "./Postbacks.vue?vue&type=template&id=1b2927fd&"
import script from "./Postbacks.vue?vue&type=script&lang=js&"
export * from "./Postbacks.vue?vue&type=script&lang=js&"
import style0 from "./Postbacks.vue?vue&type=style&index=0&id=1b2927fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports